<template>
  <div class="crewHome">
    <div class="crewHome-content">
      <!-- <el-form :inline="true" :model="formInline" class="other-form-inline">
        <el-form-item class="flex-form">
          <el-date-picker
            class="hide-icon"
            type="date"
            placeholder="开始时间"
            v-model="formInline.date1"
            style="width: 100px"
          ></el-date-picker>
          <span class="line" style="margin: 0 3px">-</span>
          <el-date-picker
            class="hide-icon"
            placeholder="结束时间"
            v-model="formInline.date2"
            style="width: 100px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="formInline.region"
            placeholder="是否加入人才储备"
            style="width: 165px"
          >
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="formInline.userName"
            placeholder="搜索姓名"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="other-search" @click="onSubmit">
            <i class="el-icon-search"></i>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="other-search" style="width: 100px" @click="inviteAdd()">
            <i class="iconfont icon-yaoqing"></i
            ><span style="font-size: 14px">邀请投递</span>
          </div>
        </el-form-item>
      </el-form> -->
      <!-- <div style="clear: both"></div> -->
      <!-- <el-divider class="other-divider"></el-divider> -->
      <div class="other-table">
        <el-table
          :data="tableData"
          style="width: 100%"
          header-row-class-name="other-header"
          row-class-name="other-row"
          height="100%"
        >
          <el-table-column prop="userName" label="姓名" min-width="100">
          </el-table-column>
          <el-table-column prop="age" label="年龄" min-width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.age">{{ scope.row.age }}岁</span>
            </template>
          </el-table-column>
          <el-table-column prop="workingYear" label="航海经验" min-width="140">
            <template slot-scope="scope">
              <span v-if="scope.row.workingYear">{{
                scope.row.workingYear
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="positionName" label="求职岗位" min-width="120">
          </el-table-column>
          <el-table-column prop="" label="登船地点" min-width="100">
            <template slot-scope="scope">
              <span
                >{{ scope.row.locationProvinceName
                }}{{
                  scope.row.locationProvinceName == scope.row.locationPortName
                    ? ""
                    : "-" + scope.row.locationPortName
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="" label="薪资" min-width="120">
            <template slot-scope="scope">
              <span
                >{{ scope.row.salaryType == "1" ? "￥" : "$"
                }}{{ scope.row.salaryBegin }}-{{ scope.row.salaryEnd }}</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <div class="other-block">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage1"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ResumeManagement, crewAudit } from "@/apis/index";
export default {
  data() {
    return {
      formInline: {},
      tableData: [],
      currentPage1: 1,
      pageNo: "1",
      total: 0,
      pageSize: 10,
    };
  },
  mounted() {
    this.getResumeManagement();
  },
  methods: {
    onSubmit() {
      this.pageNo = 1;
      this.getResumeManagement();
    },
    handleOpen() {},
    handleSizeChange(val) {
      this.pageSize = val;
      this.getResumeManagement();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getResumeManagement();
      // console.log(`当前页: ${val}`);
    },
    choseCom() {
      this.companyVisible = true;
    },
    handleClose() {
      this.companyVisible = false;
    },
    comDetail(item) {
      console.log(item);
      this.$router.push({
        name: "inviteDetail",
        params: { name: item.row.userName, userId: item.row.userId },
      });
    },
    inviteAdd() {
      this.$router.push({ name: "inviteAdd", params: { name: "邀请投递" } });
    },
    async getResumeManagement() {
      // console.log(this.$route);
      let res = await ResumeManagement({
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        jobId: this.$route.params.jobId,
        dataType: "1",
      });
      this.total = res.data.rowCount;
      this.tableData = res.data.resultList;
    },
    delInvite(scope) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          // this.$message({
          //   message: "删除成功",
          //   type: "success",
          // });
          this.delList(scope.row.userId);
          // console.log(scope);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    async delList(item) {
      await crewAudit({ userId: item, agentAuditState: "3" });
      // console.log(res);
      this.getCrewInfoList();
    },
  },
};
</script>
